import React from "react";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";

import { Modal } from "../../../../components/modals/modal";

import CodeJamLogo from "../../../../images/CodeJam_logo.svg";
import BlockJamLogo from "../../../../images/BlockJam_logo.svg";
import TextJamLogo from "../../../../images/TextJam_logo.svg";
import CloseIcon from "../../../../images/close.svg";

import { IDE_TYPE } from "../model/ide.types";
import CodeJamOptionCard from "./CodeJamOptionCard";
import { useStyles } from "../styles/CodeJamPickerModal.styles";

// Shown on the Clubs instance before opening CodeJam: lets the user choose
// between the BlockJam (block-based) and TextJam (text-based) editors.
const CodeJamPickerModal = ({ isOpen, onClose, onSelect }) => {
  const classes = useStyles();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        classes: {
          rounded: classes.paperRounded,
        },
      }}
    >
      <div className={classes.dialogBox}>
        <Box className={classes.closeRow}>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            className={classes.closeBtn}
            onClick={onClose}
          >
            <img
              alt="Close icon"
              className={classes.closeBtnIcon}
              src={CloseIcon}
            />
          </IconButton>
        </Box>

        <div className={classes.content}>
          <div className={classes.modal}>
            <img
              alt="CodeJam Logo"
              className={classes.modalLogo}
              src={CodeJamLogo}
            />
            <div className={classes.modalText}>
              <Typography className={classes.modalTitle}>
                Start Coding!
              </Typography>
              <Typography className={classes.modalDescription}>
                Pick between <b>BlockJam</b> or <b>TextJam</b> to begin your
                coding journey.
                <br />
                Select your path to start learning!
              </Typography>
            </div>
          </div>

          <div className={classes.options}>
            <Typography className={classes.question}>
              What would you like to practice today?
            </Typography>
            <CodeJamOptionCard
              logo={BlockJamLogo}
              logoAlt="BlockJam Logo"
              className={classes.optionCard}
              onClick={() => onSelect(IDE_TYPE.BLOCK_JAM)}
            >
              Drag and drop code blocks in <b>BlockJam</b> to build cool
              projects and level up your coding skills!
            </CodeJamOptionCard>
            <CodeJamOptionCard
              logo={TextJamLogo}
              logoAlt="TextJam Logo"
              className={classes.optionCard}
              onClick={() => onSelect(IDE_TYPE.TEXT_JAM)}
            >
              Write and edit your code in <b>TextJam</b> to create awesome
              projects and boost your programming abilities!
            </CodeJamOptionCard>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CodeJamPickerModal;
